package de.ohhhmhhh.frontend.admin.ui.screens.text.list

import de.ohhhmhhh.backend.models.model.text.StaticTextEntity

data class TextListState(
    val items: List<StaticTextEntity> = emptyList(),
)
